<div
  class="resend-otp-card bg-light-primary rounded-xl p-3.5 flex items-center gap-3.5 w-[290px] mx-auto"
  style="background-color: #f0f6ff"
>
  <div class="flex items-center justify-center text-gray-600">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="w-6 h-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.6"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 6v6l4 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  </div>
  <div class="flex flex-col text-start">
    <span class="text-gray-600 dark:text-gray-300 text-2sm font-medium"
      >Didn't receive the code?</span
    >
    <div class="flex items-center gap-1 text-2sm font-semibold mt-0.5">
      <a
        class="transition-colors duration-200"
        [ngClass]="{
          'text-gray-500 cursor-not-allowed pointer-events-none':
            timer > 0 || isLoading,
          'text-default-primary cursor-pointer hover:underline':
            timer === 0 && !isLoading,
        }"
        (click)="resendOtp()"
      >
        Resend OTP
      </a>
      <span *ngIf="timer > 0" class="text-gray-500 font-normal"
        >in {{ formattedTimer }}s</span
      >
      <div class="loader ms-2" *ngIf="isLoading"></div>
    </div>
  </div>
</div>
